module.exports = __webpack_public_path__ + "static/media/figma.e86a5199.png";